const en = {
	// 账户余额
	accountBalance: {
		title: 'Account Balance',
		account: 'Account',
		withdraw: 'WITHDRAW',
		balance: 'Balance',
		frozenBalance: 'Frozen Balance',
		RollingReserveBalance: 'Rolling Reserve Balance',
		availableBalance: 'Available Balance',
		availableBalance2: 'Actual total withdrawal amount',
		fixedReserveBalance: 'Fixed Deposit Balance',
		accountDetail: 'Account Detail',
		group: 'Group',
		storeName: 'Group/Website',
		storeName1: 'Website',
		businessType: 'Fund Type',
		revenueExpense: 'Income/Outgo',
		revenue: 'Income',
		expense: 'Outgo',
		transactionId: 'Flow ID',
		orderId: 'Merchant Transaction ID',
		time: 'Settlement Time',
		search: 'SEARCH',
		clear: 'Reset',
		exportExcel: 'Export',
		balanceAccount: 'Account Details',
		frozenAccount: 'Frozen Balance',
		RollingReserveAccount: 'Rolling Reserve Balance',
		fixedReserveAccount: 'Fixed Deposit Balance',
		amount: 'Total Amount',
		hideDetail: 'HIDE DETAIL',
		showDetail: 'SHOW DETAIL'
	},

	filter: {
		webSite: 'Website',
		all: 'All',
		status: 'Status',
		groupName: 'Group',
		remitted: 'SUCCESS',
		remitting: 'INPROCESS',
		failed: 'FAILED',
		_return: 'RETURN',
		date: 'Date',
		selectDate: 'Select the date',
		quicklySelect: {
			lab: 'Quick selection',
			range: {
				today: 'Today',
				lastWeek: 'Last week',
				lastMonth: 'Last month',
				lastYear: 'Last year'
			}
		}
	},
	tableColumns: {
		withdrawalTime: 'Withdrawal Time',
		withdrawalFlowID: 'Withdrawal Flow ID',
		webSite: 'Website',
		groupName: 'Group',
		paymentAccount: 'Payment Account',
		withdrawalAmount: 'Withdrawal Amount',
		withdrawalFee: 'Withdrawal Fee',
		transferredAmount: 'Transferred Amount',
		remittanceTime: 'Remittance Time',
		status: 'Status',
		orderStatus: 'Order Status',
		riskDetail: 'Details',
		noData: 'No Data',
		exportFaild: 'Export Faild , please try later',
		operator: 'Operator',
		riskFieldTips: 'After assessment, the withdrawable amount for this transaction is {0} {1}. Please proceed with a new request.',
		receiptBtn: 'download'
	},
	unsettled: {
		currency: 'Currency',
		totalAmount: 'Total amount (converted to USD) is probably',
		title: 'Unsettled Balance',
		view: 'View',
		amount: 'Total amount',
	    storeName: 'Website/Group',
		omniStoreName: 'Store/Website/Group',

		orderId: 'Merchant Transaction ID',
		flowId: 'Purchase Transaction ID',
		usdAmount: 'Convert to USD',
		transRecord: 'Unsettled Balance Detail',
		time: 'Transaction time',
		tip: '* All balance in this page is unsettled. Please subject to actual received amount.',
		amountTip: 'The statistical amounts displayed below are transaction amounts and do not include any fees.',
		more: 'Show all',
		collapse: 'Collapse',
		totalAmountUSD: 'Total amount(USD)'

	},
	withdrawalDetail: {
		title: 'Withdrawal Detail',
		dialogTitle: 'Withdrawal Detail',
		groupName: 'Group',
		withdrawalFlowID: 'Withdrawal Flow ID',
		search: 'Search',
		reset: 'Reset'
	}
}

export default en
